import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import ItemSkeleton from './ItemSkeleton';

const ITEM_LOADING = 3;

export default function ListItemSkeleton({ numOfItems = ITEM_LOADING }) {
  return (
    <Stack>
      <Stack
        alignItems="center"
        direction="row"
        display="flex"
        justifyContent="space-between"
      >
        <Skeleton
          height={25}
          width={64}
        />
        <Skeleton
          height={20}
          width={64}
        />
      </Stack>
      <Stack aria-label="Loading list data">
        {Array.from({ length: numOfItems }, (_, key) => (
          <ItemSkeleton key={key} />
        ))}
      </Stack>
    </Stack>
  );
}

ListItemSkeleton.propTypes = {
  numOfItems: PropTypes.number
};
